import { render, staticRenderFns } from "./wellness-services.vue?vue&type=template&id=4d15892e&"
import script from "./wellness-services.vue?vue&type=script&lang=js&"
export * from "./wellness-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports